import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, UsersIcon, FolderIcon, TrendingUpIcon, CalendarIcon, MessageSquareIcon, LayoutDashboardIcon, DatabaseIcon } from 'lucide-react';
import { ActionSuggestion } from '../../lib/actionSuggestionDetector';
interface ActionSuggestionsProps {
  suggestions: ActionSuggestion[];
  onAction: (suggestion: ActionSuggestion) => void;
}
export function ActionSuggestions({
  suggestions,
  onAction
}: ActionSuggestionsProps) {
  if (suggestions.length === 0) return null;
  const getIcon = (action: string) => {
    if (action.includes('people')) return UsersIcon;
    if (action.includes('spaces')) return DatabaseIcon;
    if (action.includes('analytics')) return TrendingUpIcon;
    if (action.includes('assets')) return FolderIcon;
    if (action.includes('meeting')) return CalendarIcon;
    if (action.includes('chat')) return MessageSquareIcon;
    if (action.includes('account')) return LayoutDashboardIcon;
    return ArrowRightIcon;
  };
  return <motion.div initial={{
    opacity: 0,
    y: 5
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.2,
    delay: 0.1
  }} className="mt-3 flex flex-wrap gap-2" data-id="element-279">
      {suggestions.map((suggestion, index) => {
      const Icon = getIcon(suggestion.action);
      return <motion.button key={suggestion.id} initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.15,
        delay: index * 0.05
      }} onClick={() => onAction(suggestion)} className="group flex items-center gap-2 px-3 py-1.5 bg-slate-800/60 hover:bg-slate-700/80 border border-slate-700/50 hover:border-slate-600 rounded-lg text-xs font-medium text-slate-300 hover:text-white transition-all hover:shadow-lg hover:shadow-blue-500/10" data-id="element-280">
            <Icon className="w-3.5 h-3.5 text-slate-400 group-hover:text-blue-400 transition-colors" data-id="element-281" />
            <span data-id="element-282">{suggestion.label}</span>
          </motion.button>;
    })}
    </motion.div>;
}